export default __webpack_public_path__ + "static/media/logoImg.9c3be860.png";